// This file is used for setting the webRootContext

const webRootContext = "/observership";

export default webRootContext;